module.exports = __webpack_public_path__ + "account_center_logo.3e0b025f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/account_center_logo.svg
 ** module id = 958
 ** module chunks = 0
 **/